import { useContext } from "react";
import { Thead, THT, THTS } from "../../components";
import TableContext from "../Provider/TableContext";

function TableHead() {
  const { setOrder = () => {} } = useContext(TableContext);

  return (
    <Thead>
      <THTS txt="Name" field="name" setOrder={setOrder} />
      <THTS txt="Number Of Stops" field="no_of_stops" setOrder={setOrder} />
      <THTS txt="Description" field="description" setOrder={setOrder} />
      <THT txt="Actions" />
    </Thead>
  );
}

export default TableHead;
